import type { Socket } from 'socket.io-client'

// Active sockets register here so cross-cutting code (e.g. the 401 handler in
// services/api.ts) can tear them down on logout instead of leaving a socket
// running with a stale token. useSocket adds/removes its socket here.
const sockets = new Set<Socket>()

export const registerSocket = (socket: Socket): void => {
  sockets.add(socket)
}

export const unregisterSocket = (socket: Socket): void => {
  sockets.delete(socket)
}

export const disconnectAllSockets = (): void => {
  sockets.forEach((socket) => {
    try {
      socket.disconnect()
    } catch {
      /* best-effort teardown */
    }
  })
  sockets.clear()
}
